import moment from "moment";
import styled from "styled-components";
import React, { useState } from "react";
import ChevronDown from "sushiweb/Icons/all/ChevronDown";
import { FlexContainer, Pill } from "../../../constants/assets/containers";
import variables from "../../../constants/assets/variables";
import TableFields from "../../../constants/FleetCoachAppReleases/TableFields.json";
import { getPath } from "../../../utils";
import Table from "../../Common/Table";
import ActionBarList from "../ActionBarList";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

const AppReleasesList = (props) => {
  const {
    // props
    permissions,
    list,
    handleRowClick,
    activeAppRelease,
    setActiveAppRelease,
  } = props;
  const [showActionBar, setShowActionBar] = useState(false);
  const [expandedText, setExpandedText] = useState("");
  const [actionCoord, setActionCoord] = useState({
    top: "",
    right: "",
  });

  const handleActions = (action_id, activeRelease) => {
    const activeAct = document.getElementById(`${action_id}`);

    setShowActionBar(true);
    setActiveAppRelease(activeRelease);

    if (activeAct) {
      setActionCoord({
        top: activeAct.getBoundingClientRect().top + 10,
        right: window.innerWidth - activeAct.getBoundingClientRect().right,
      });
      activeAct.style.zIndex = 200;
    }
  };

  const handleBlur = () => {
    setShowActionBar(false);
  };

  const handleTextExpand = (action, index) => {
    setExpandedText(`${action}_${index}`);
  };

  const getFieldValue = (item, key, index) => {
    switch (key) {
      case "created_at":
      case "updated_at":
        return item[key]
          ? moment(item[key]).format("DD-MM-YYYY hh:mm A")
          : "NA";
      case "release_notes":
        return item[key].length > 150 ? (
          expandedText &&
          expandedText.split("_")[1] == index &&
          expandedText.split("_")[0] === "collapse" ? (
            <span>
              {item[key] + " ..."}
              <span
                className="expand-collapse-text"
                onClick={() => handleTextExpand("expand", index)}
              >
                collapse
              </span>
            </span>
          ) : (
            <span>
              {item[key].substr(0, 150) + "..."}
              <span
                className="expand-collapse-text"
                onClick={() => handleTextExpand("collapse", index)}
              >
                expand
              </span>
            </span>
          )
        ) : (
          item[key]
        );
      case "actions":
        return (
          <FlexContainer
            justify="flex-start"
            onClick={() => {
              handleActions(`actions_${index}`, item);
            }}
            className={"edit-options cursor-pointer actions-holder"}
            id={`actions_${index}`}
          >
            {" "}
            <span>Actions</span> <ChevronDown color={variables.primaryColor} />{" "}
          </FlexContainer>
        );
      case "expected_fc_count":
      case "current_fc_count":
        return getPath(item, key, "0");
      default:
        return getPath(item, key, "NA");
    }
  };

  return (
    <AppReleasesListContainer>
      <Table list={list} getFieldValue={getFieldValue} fields={TableFields} />
      {showActionBar && (
        <ActionBarList
          handleBlur={handleBlur}
          permissions={permissions}
          top={actionCoord.top}
          right={actionCoord.right}
          activeAppRelease={activeAppRelease}
          handleRowClick={handleRowClick}
        />
      )}
    </AppReleasesListContainer>
  );
};

const AppReleasesListContainer = styled.div`
  height: calc(100vh - 215px);
  .actions-holder {
    text-decoration: none;
  }
  .expand-collapse-text {
    color: ${variables.blue500};
    cursor: pointer;
  }
  .tableBodyRow {
    td {
      max-width: 350px;
    }
  }
`;

export default connect(null, null)(AppReleasesList);
